// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1a-q";
export var animationRelative = "_1a-p";
export var backdropBlur = "_1a-0";
export var detailLabelCell = "_1a-12";
export var detailTable = "_1a-11";
export var detailValueCell = "_1a-13";
export var docIconBox = "_1a-1d";
export var docIconBoxMd = "_1a-1f";
export var docIconBoxSm = "_1a-1e";
export var docTypeRow = "_1a-16";
export var docTypeRowInner = "_1a-17";
export var dropdownMatchDatePicker = "_1a-3";
export var evidenceCardContent = "_1a-1c";
export var fileUploadSpin = "_1a-j";
export var gorgiasOpenButton = "_1a-15 _1a-d";
export var gorgiasTicketCard = "_1a-14";
export var heroModalFooterButton = "_1a-18";
export var hiddenContainer = "_1a-o";
export var iconPrimary = "_1a-1g";
export var iconQuaternary = "_1a-1i";
export var iconTertiary = "_1a-1h";
export var integrationCard = "_1a-1";
export var integrationLogoBox = "_1a-2";
export var mainColumnSticky = "_1a-1b";
export var maxWidthContainer = "_1a-19";
export var modalContentBody = "_1a-a";
export var modalHeaderImage = "_1a-5";
export var modalImageLabel = "_1a-7";
export var modalImageOverlay = "_1a-6";
export var modalImageSubtitle = "_1a-9";
export var modalImageTitle = "_1a-8";
export var modalImageWrapper = "_1a-4";
export var modalStickyFooter = "_1a-b";
export var removeButton = "_1a-e";
export var sidebarColumn = "_1a-1a";
export var spinner = "_1a-i";
export var timelineLine = "_1a-y";
export var timelineLineBlack = "_1a-10 _1a-y";
export var timelineLineGray = "_1a-z _1a-y";
export var timelineLineHeight = "_1a-x";
export var tlDotActivate = "_1a-u";
export var tlDotActivateAnim = "_1a-t";
export var tlDotHide = "_1a-s";
export var tlDotHideAnim = "_1a-r";
export var tlLineActivate = "_1a-w";
export var tlLineActivateAnim = "_1a-v";
export var uploadHint = "_1a-n";
export var uploadIconBox = "_1a-k";
export var uploadLabel = "_1a-m";
export var uploadText = "_1a-l";
export var uploadZone = "_1a-f";
export var uploadZoneCursorDefault = "_1a-h";
export var uploadZoneCursorPointer = "_1a-g";
export var uploadedFileRow = "_1a-c";
export var viewButton = "_1a-d";